import React, {ChangeEvent, HTMLAttributes} from 'react'
import classNames from 'classnames';
import styles from './switch.module.scss';

interface Props {
    checked: boolean;
    onChange: (value: boolean) => void;
    label: string;
    name: string;
    labelProps?: HTMLAttributes<HTMLLabelElement>
    disabled?: boolean;
}

export default function TSwitch(props: Props) {
    const {checked, label, name, onChange, disabled} = props;

    const handleChangeDefault = (e: ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.checked)
    }

    return <label
        {...props.labelProps}
        htmlFor={name}
        className={classNames(styles.switchLabel, props.labelProps?.className)}
    >
        <input
            className={styles.switchInput}
            name={name} 
            type='checkbox' 
            role='switch' 
            checked={checked} 
            onChange={handleChangeDefault}
            disabled={disabled}
        />
        {label}
    </label>

    
}
